import logo from "../images/logo.png";

export function normalizeBidImageUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (raw.startsWith("//")) return `https:${raw}`;
  if (window.location.protocol === "https:" && raw.startsWith("http://")) {
    return `https://${raw.slice(7)}`;
  }
  return raw;
}

const CLOUDINARY_IMAGE_PRESETS = {
  card: "f_auto,q_auto:good,c_limit,w_800",
  main: "f_auto,q_auto:good,c_limit,w_1200",
  thumbnail: "f_auto,q_auto:eco,c_fill,w_240,h_180",
  lightbox: "f_auto,q_auto:good,c_limit,w_2000",
};

export function getBidImageUrl(value, preset = "main") {
  const normalizedUrl = normalizeBidImageUrl(value);
  if (!normalizedUrl || !normalizedUrl.includes("res.cloudinary.com")) {
    return normalizedUrl;
  }

  const transformation = CLOUDINARY_IMAGE_PRESETS[preset] || CLOUDINARY_IMAGE_PRESETS.main;
  const uploadMarker = "/image/upload/";
  const markerIndex = normalizedUrl.indexOf(uploadMarker);
  if (markerIndex === -1) return normalizedUrl;

  const prefixEnd = markerIndex + uploadMarker.length;
  return `${normalizedUrl.slice(0, prefixEnd)}${transformation}/${normalizedUrl.slice(prefixEnd)}`;
}

function withRetryParameter(url) {
  const cleanUrl = String(url || "").replace(/([?&])bidit_retry=\d+(&?)/, (_, prefix, tail) =>
    tail ? prefix : ""
  );
  return `${cleanUrl}${cleanUrl.includes("?") ? "&" : "?"}bidit_retry=${Date.now()}`;
}

export function retryImageLoad(event) {
  const image = event.currentTarget;

  if (image.dataset.biditFallback === "1") return;

  if (image.dataset.biditRetried !== "1") {
    image.dataset.biditRetried = "1";
    const originalSrc = image.dataset.biditOriginalSrc || image.src;
    image.dataset.biditOriginalSrc = originalSrc;
    image.style.backgroundColor = "#eef6fc";

    window.setTimeout(() => {
      image.src = withRetryParameter(originalSrc);
    }, 350);
    return;
  }

  image.dataset.biditFallback = "1";
  image.style.objectFit = "contain";
  image.style.backgroundColor = "#eef6fc";
  image.style.padding = "18px";
  image.src = logo;
}

export function resetImageRetryState(event) {
  const image = event.currentTarget;
  delete image.dataset.biditRetried;
  delete image.dataset.biditFallback;
  delete image.dataset.biditOriginalSrc;
  image.style.backgroundColor = "";
  image.style.padding = "0";
}
